import { configureStore } from "@reduxjs/toolkit";
import mainApi from "../apis/mainApi";
import authSlice from "../slices/authSlice";
import examSlice from "../slices/examSlice";
import { coursePaymentsApi } from "../apis/coursePaymentsApi";
import { setupListeners } from "@reduxjs/toolkit/query";
import { promoCodesApi } from "../apis/promoCodesApi";
import { smsApi } from "../apis/smsApi";
import ExamSidebarSliceReducer from "../slices/ExamSidebarSlice";
import OmrSliceReducer from "../slices/omrSlice";

export const store = configureStore({
  reducer: {
    [mainApi.reducerPath]: mainApi.reducer,
    [examSlice.reducerPath]: examSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [coursePaymentsApi.reducerPath]: coursePaymentsApi.reducer,
    [promoCodesApi.reducerPath]: promoCodesApi.reducer,
    [smsApi.reducerPath]: smsApi.reducer,
    examSidebar: ExamSidebarSliceReducer,
    omrToggle: OmrSliceReducer,
  },
  middleware: (getDefaultMiddlewares) => {
    return getDefaultMiddlewares()
      .concat(mainApi.middleware)
      .concat(coursePaymentsApi.middleware)
      .concat(promoCodesApi.middleware)
      .concat(smsApi.middleware);
  },
});

setupListeners(store.dispatch);
